import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle, Container, Row, Col } from 'reactstrap';
import LineChartComponent from 'components/chart/LineChartComponent';
import { phProcessData } from 'components/chart/phProcessData';
import { coolantProcessData } from 'components/chart/coolantProcessData';
import { generateSevenDayArray } from 'components/chart/generateSevendays';
import SecondLineChart from 'components/chart/SecondLineChart';
import { Divider } from '@mui/material';

function ChartScreen({ data, startDate, endDate }) {
  
  const [phData, setPHData] = useState([]);
  const [phLabels, setPHLabels] = useState([]);
  const [phLowerLimit, setPHLowerLimit] = useState([]);
  const [phHigherLimit, setPHHigherLimit] = useState([]);
  const [phControlLine, setPHControlLine] = useState([]);

  const [coolantData, setcoolantData] = useState([]);
  const [coolantLabels, setcoolantLabels] = useState([]);
  const [coolantLowerLimit, setcoolantLowerLimit] = useState([]);
  const [coolantHigherLimit, setcoolantHigherLimit] = useState([]);
  const [coolantControlLine, setcoolantControlLine] = useState([]);

  useEffect(() => {
    if (data.length > 0) {
      const { phLabels, phLowerLimit, phHigherLimit, phControlLine, phData, coolantData } = phProcessData(data);
      const { coolantLabels, coolantLowerLimit, coolantHigherLimit, coolantControlLine } = coolantProcessData(data)
      setPHLabels(phLabels);
      setPHLowerLimit(phLowerLimit);
      setPHHigherLimit(phHigherLimit);
      setPHControlLine(phControlLine);
      setPHData(phData);
      setcoolantData(coolantData);
      setcoolantLabels(coolantLabels);
      setcoolantLowerLimit(coolantLowerLimit);
      setcoolantHigherLimit(coolantHigherLimit);
      setcoolantControlLine(coolantControlLine);
    } else {
      setPHLabels(generateSevenDayArray(startDate, endDate) || []);
      setPHLowerLimit([]);
      setPHHigherLimit([]);
      setPHControlLine([]);
      setPHData([]);
      setcoolantData([]);
      setcoolantLabels(generateSevenDayArray(startDate, endDate) || []);
      setcoolantLowerLimit([]);
      setcoolantHigherLimit([]);
      setcoolantControlLine([]);
    }
  }, [data]);

  return (
    <div  >
     <Row className="justify-content-center">

      <Col xs="12" md='12' lg='6' className="mb-2 ">
        <Card className='chart_card'>
          <CardBody className='p-2 chart_card_body' >
            <CardTitle className='ml-2 chart_card_title'>pH</CardTitle>
            <LineChartComponent
              dataInfo={coolantData}
              labelData={phLabels}
              // lowerLimitData={phLowerLimit}
              // higherLimitData={phHigherLimit}
              controlLineData={phData}
              dataSet={['Coolant pH', 'Conc Lower Limit', 'Conc Higher Limit', 'Water pH']}
            />
            <div className="chart_card_circle_color d-flex align-items-end mt-2">
              {/* <div>
                <span className="color_circle circle_first_color" style={{backgroundColor:'red'}}></span>
                <p>Conc Higher Limit</p>
              </div>
              <div className='ml-2'>
                <span className="color_circle circle_second_color" style={{backgroundColor:'red'}}></span>
                <p>Conc Lower Limit</p>
              </div> */}
              <div className='ml-2'>
                <span className="color_circle circle_third_color" style={{backgroundColor:'blue'}}></span>
                <p>Water pH</p>
              </div>
              <div className='ml-2'>
                <span className="color_circle circle_fourth_color" style={{backgroundColor:'green'}}></span>
                <p>Coolant pH</p>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>

      <Col xs="12" md='12' lg='6' className="mb-2 " >
        <Card className='chart_card' >
          <CardBody className='p-2 chart_card_body'>
            <CardTitle  className='ml-2 chart_card_title'>% Brix Concentration</CardTitle>
            <SecondLineChart
              labelData={coolantLabels}
              lowerLimitData={coolantLowerLimit}
              higherLimitData={coolantHigherLimit}
              controlLineData={coolantControlLine}
              dataSet={['', 'Conc Lower Limit', 'Conc Higher Limit', '% Conc']}
            />
            <div className="chart_card_circle_color d-flex align-items-end mt-2">
              <div>
                <span className="color_circle circle_fifth_color" style={{backgroundColor:'red'}}></span>
                <p>Conc Higher Limit</p>
              </div>
              <div className='ml-2'>
                <span className="color_circle circle_sixth_color" style={{backgroundColor:'red'}}></span>
                <p>Conc Lower Limit</p>
              </div>
              <div className='ml-2'>
                <span className="color_circle circle_seventh_color" style={{backgroundColor:'blue'}}></span>
                <p>% Brix Concentration</p>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
    </div>
  );
}

export default ChartScreen;